import React from "react"
import Data from "./data"
import Card from "@components/Card"
import Grid from "@components/Grid"
import Section, { SectionHeadline } from "@components/Section"
import Button from "@components/UI/Button"
import Container from "@components/UI/Container"
import Icon from "@components/UI/Icon"
import Link from "@components/UI/Link"
import Picture from "@components/UI/Picture"
import Heading from "@components/UI/Typography/Heading"
import Paragraph from "@components/UI/Typography/Paragraph"

const Cards = () => {
  const { cards } = Data

  return (
    <Section mods={{ home: true }}>
      <Container>
        <SectionHeadline mods={{ center: true }}>
          <Heading tag="h2">
            <span className={"text-violet-700"}>Time tracking</span> data
          </Heading>
        </SectionHeadline>

        <Grid
          xs={1}
          md={3}
          gx={6}
          gy={10}
        >
          {cards.map((item) => (
            <Card
              key={item.id}
              mods={{
                shadow: true,
                hover: true,
                "text-block": true,
              }}
              className="p-6"
              image={
                <Picture
                  image={item.image}
                  alt={item.alt}
                  sizes="(min-width: 1024px) 25vw, (min-width: 768px) 30vw, (min-width: 425px) 50vw, 50vw"
                  props={{ height: 60 }}
                  mods={{ centered: false }}
                  className="pb-4"
                />
              }
              body={{
                title: <h3 className="heading h6">{item.title}</h3>,
                /* text: (
                                <Button
                                    tag='a'
                                    type='link'
                                    href={ item.url }
                                    variant={ 'link_external' }
                                    mods={ { 'no-spacing': true, 'link': true } }
                                    >
                                    Learn More
                                </Button>
                                )*/
              }}
              footer={
                <Link
                  href={item.url}
                  mods={{ stretched: true }}
                  linkProps={{ title: item.title }}
                >
                  <span className="hidden">{item.title}</span>
                </Link>
              }
            />
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default Cards
